import { Routes } from '@angular/router';
import { StudentPortalLayoutComponent } from '../student-portal/student-portal-layout/student-portal-layout.component';
import { DashboardComponent } from '../student-portal/dashboard/dashboard.component';
import { ScholarshipsMapComponent } from '../student-portal/resources/scholarships-map/scholarships-map.component';
import { ChecklistComponent } from '../student-portal/checklist/checklist.component';
import { InstituteDetailComponent } from '../student-portal/institute-detail/institute-detail.component';
import { ViewProfileComponent } from '../student-portal/view-profile/view-profile.component';
import { CompleteYourProfileComponent } from '../student-portal/complete-your-profile/complete-your-profile.component';
import { InstituteSearchComponent } from '../student-portal/institute-search/institute-search.component';
import { EssayPilotComponent } from '../student-portal/essay-pilot/essay-pilot.component';
import { MentorsMeComponent } from '../student-portal/mentors-me/mentors-me.component';
import { AccountCentreComponent } from '../student-portal/account-centre/account-centre.component';
import { MentorProfileComponent } from '../student-portal/mentor-profile/mentor-profile.component';
import { PeerComponent } from '../student-portal/peer/peer.component';
import { PeerProfileComponent } from '../student-portal/peer-profile/peer-profile.component';
import { ScholarshipsComponent } from '../student-portal/resources/scholarships/scholarships.component';
import { RoiCalculatorComponent } from '../student-portal/resources/roi-calculator/roi-calculator.component';

import { SummerProgramsComponent } from '../student-portal/resources/summer-programs/summer-programs.component';
import { SummerSchoolAbroadComponent } from '../student-portal/resources/summer-school-abroad/summer-school-abroad.component';
import { BlogsComponent } from '../student-portal/resources/blogs/blogs.component';
import { VlogsComponent } from '../student-portal/resources/vlogs/vlogs.component';
import { VisaAndWorkEligibilityComponent } from '../student-portal/resources/visa-and-work-eligibility/visa-and-work-eligibility.component';
import { CollegeRankComponent } from '../student-portal/resources/college-rank/college-rank.component';
import { AdmissionCalendarStudentComponent } from '../student-portal/resources/admission-calendar-student/admission-calendar-student.component';
import { DeadlineCalendarComponent } from '../student-portal/resources/deadline-calendar/deadline-calendar.component';
import { ProfileBuildingOpportunitiesComponent } from '../student-portal/resources/profile-building-opportunities/profile-building-opportunities.component';
import { ScheduleACallComponent } from '../student-portal/schedule-acall/schedule-acall.component';
import { SchedulePeerCallComponent } from '../student-portal/schedule-peer-call/schedule-peer-call.component';
import { RecentSubmissionsComponent } from '../student-portal/essay-pilot/recent-submissions/recent-submissions.component';
import { PsychometricTestComponent } from '../student-portal/psychometric-test/psychometric-test.component';
import { PermissionGuard } from '../guards/permission.guard';
import { UserRole } from '../models/enums/UserRole';
import { PaymentFailureComponent } from '../pay-now/pay-failure/payment-failure.component';
import { ChatComponent } from '../student-portal/chat/chat.component';
import { ShopComponent } from '../student-portal/shop/shop.component';
import { ShopBillingComponent } from '../student-portal/shop-billing/shop-billing.component';
import { ApplicationFormComponent } from '../student-portal/application-form/application-form.component';
import { StudentDocumentVaultComponent } from '../student-portal/student-document-vault/student-document-vault.component';
import { DAComponent } from '../student-portal/direct-apply/direct-apply.component';
import { MyCollegesComponent } from '../student-portal/my-colleges/my-colleges.component';
import { DirectApplyLandingComponent } from '../direct-apply/direct-apply-landing/direct-apply-landing.component';
import { DirectApplyComponent } from '../direct-apply/direct-apply.component';
import { ReviewComponent } from '../direct-apply/review/review.component';
import { ExpertCheckoutComponent } from '../direct-apply/expert-checkout/expert-checkout.component';
export const studentRoutes: Routes = [
  {
    path: 'portal', component: StudentPortalLayoutComponent,
    data: { portal: 'student' },
    children: [
      {
        path: 'application-form', component: ApplicationFormComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: '', redirectTo: 'dashboard', pathMatch: 'full'
      },
      {
        path: 'dashboard', component: DashboardComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'direct-apply',
        component: DirectApplyComponent,
        data: { expectedRoles: [UserRole.Student] },
        canActivate: [PermissionGuard]
      },
      {
        path: 'direct-apply/payment-review/:txnId',
        component: DirectApplyComponent,
        data: { expectedRoles: [UserRole.Student] },
        canActivate: [PermissionGuard]
      },
      {
        path: 'direct-apply/payment-expert/:txnId',
        component: DirectApplyComponent,
        data: { expectedRoles: [UserRole.Student] },
        canActivate: [PermissionGuard]
      },
      // {
      //   path: 'my-institutes',
      //   component: ChecklistComponent,
      //   data: {
      //     expectedRoles: [UserRole.Student],
      //   },
      //   canActivate: [PermissionGuard]
      // },
      {
        path: ':id/institute',
        component: InstituteDetailComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard],
        pathMatch: 'prefix'
      },
      {
        path: 'view-profile/:id',
        component: ViewProfileComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'complete-profile',
        component: CompleteYourProfileComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'institute-search',
        component: InstituteSearchComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'essay-pilot',
        component: EssayPilotComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'student-document-vault',
        component: StudentDocumentVaultComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'mentor-me',
        component: MentorsMeComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'account-centre',
        component: AccountCentreComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]

      },
      {
        path: 'mentor-profile/:id',
        component: MentorProfileComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'peer',
        component: PeerComponent,
      },
      {
        path: 'peer-profile/:id',
        component: PeerProfileComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'scholarships',
        component: ScholarshipsComponent,
      },
      {
        path: 'scholarships-explore',
        redirectTo: 'scholarships',
        pathMatch: 'full'
      },
      {
        path: 'scholarships-map',
        component: ScholarshipsMapComponent,
      },
      {
        path: 'roi-calculator',
        component: RoiCalculatorComponent,
      },
      {
        path: 'summer-programs',
        component: SummerProgramsComponent,
      },
      {
        path: 'summer-school-abroad',
        component: SummerSchoolAbroadComponent,
      },
      {
        path: 'blogs',
        component: BlogsComponent,
      },
      {
        path: 'vlogs',
        component: VlogsComponent,
      },
      {
        path: 'visa-and-work-eligibility',
        component: VisaAndWorkEligibilityComponent,
      },
      {
        path: 'college-rank',
        component: CollegeRankComponent,
      },
      {
        path: 'admission-calendar-student',
        component: AdmissionCalendarStudentComponent,
      },
      {
        path: 'deadline-calendar',
        component: DeadlineCalendarComponent,
      },
      {
        path: 'profile-building-opportunities',
        component: ProfileBuildingOpportunitiesComponent,
      },
      {
        path: 'schedule-call/:id',
        component: ScheduleACallComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'schedule-peer-call/:id',
        component: SchedulePeerCallComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'checklist',
        component: ChecklistComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'recent-submissions',
        component: RecentSubmissionsComponent,
      },
      {
        path: 'psychometric-test',
        component: PsychometricTestComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'pay-failure/:transactionId',
        component: PaymentFailureComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'chat',
        component: ChatComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'services',
        component: ShopComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'shop-billing',
        component: ShopBillingComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'direct-apply',
        component: DirectApplyComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'my-institutes',
        component: MyCollegesComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'da-forms',
        component: DAComponent,
        data: {
          expectedRoles: [UserRole.Student],
        },
        canActivate: [PermissionGuard]
      },
    ]
  }
];

